import styled from "styled-components";
import NavBack from "../../assets/icon/lnb_next_arrow.png";

export const Page = styled.div`
  min-height: calc(100vh - 68px);
  padding-top: 68px;
  width: 100vw;
  background-color: var(--semi-brown);
  margin-bottom: 60px;
  .section {
    box-shadow: 5px 5px 5px rgba(54, 28, 11, 0.1);
    background-color: var(--white);
    min-height: 800px;
    width: 1280px;
    margin: auto;
    border: 1px solid #d9d1ca;

    @media (max-width: 1280px) {
      width: 90vw;
    }
  }

  .inner {
    width: 100%;
    box-sizing: border-box;
    padding: 0px 50px 60px 50px;
    @media (max-width: 1024px) {
      padding: 0px 12px 24px 12px;
    }
  }

  .page-text {
    padding: 0 30px;
    width: 100%;
    box-sizing: border-box;
    position: relative;
    line-height: 1.9;
    font-size: 18px;
    margin-top: 24px;

    &.car-introduce {
      display: grid;
      grid-template-columns: minmax(0, 1fr) 470px;
      align-items: center;
      gap: 30px;

      .kor,
      .eng {
        grid-column: 1;
        grid-row: 1;
        min-width: 0;
      }

      .car-introduce-image {
        grid-column: 2;
        grid-row: 1;
        width: 100%;
        display: flex;
        justify-content: flex-end;
        align-items: center;
      }

      .hat-img {
        position: static !important;
        top: auto !important;
        right: auto !important;
        bottom: auto !important;
        left: auto !important;
        transform: none !important;

        display: block;
        width: 100%;
        max-width: 470px;
        height: auto;
        object-fit: contain;
        margin: 0;
      }
    }

    .page-text-flex {
      display: flex;
      gap: 60px;
      margin-bottom: 24px;
    }

    .page-text-title {
      font-weight: bold;
      font-size: 24px;
    }

    @media (max-width: 920px) {
      font-size: 14px;
      padding: 0 12px;
      word-break: keep-all;
      margin-top: 12px;
      > .hat-img {
        position: static !important;
        top: auto !important;
        right: auto !important;
        bottom: auto !important;
        left: auto !important;
        transform: none !important;

        display: block;
        width: 40% !important;
        max-width: 180px;
        height: auto !important;
        margin: 16px 0 0 auto !important;
        object-fit: contain;
      }
      &.car-introduce {
        display: block;

        .car-introduce-image {
          width: 100%;
          display: flex;
          justify-content: flex-end;
          margin-top: 18px;
        }

        .hat-img {
          position: static !important;
          top: auto !important;
          right: auto !important;
          bottom: auto !important;
          left: auto !important;
          transform: none !important;

          width: 55% !important;
          max-width: 360px !important;
          height: auto !important;
          margin: 0 !important;
        }
      }

      .page-text-flex {
        display: block;

        > div {
          width: 100%;
          margin-bottom: 12px;
        }
      }

      .page-text-title {
        font-size: 16px;
      }
    }
  }

  .hat-img {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    right: 0;
    // height: 300px;
  }

  .fullsize-map {
    width: 100%;
    margin-top: 32px;
  }
    .map-kor,
.map-eng {
  width: 100%;
  margin-top: 32px;
}

.map-eng {
  display: none;
}
  .sale-bus-title {
    font-size: 20px;
    font-weight: bold;
    color: var(--dark);
  }
  .sale-bus-list {
    display: flex;
    gap: 24px;
    align-items: center;
    width: 100%;
    margin-top: 24px;
    margin-bottom: 30px;
    @media (max-width: 768px) {
      gap: 16px;
      flex-wrap: wrap;
      & > img {
        width: 100%;
        border-radius: 10px;
      }
    }

    .sale-bus-item {
      width: calc((100% - 72px) / 4);

      .sale-bus-img {
        display: block;
        width: 100%;
        height: 180px;
        object-fit: cover;
        border-radius: 10px;
        border: 1px solid #ccc;
        box-sizing: border-box;
      }

      .sale-bus-name {
        width: 100%;
        font-size: 14px;
        font-weight: bold;
        text-align: center;
        color: var(--dark);
        margin-top: 8px;
      }

      @media (max-width: 768px) {
        width: calc((100% - 16px) / 2);
        .sale-bus-img {
          height: auto;
        }
      }
    }
  }

  .sale-vietnam-img {
    width: 20%;
    height: 200px;
    object-fit: cover;
  }


  .sale-bus-list2 {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(170px, 1fr));
  gap: 20px;
  width: 100%;
  margin-top: 24px;
  margin-bottom: 30px;

  .sale-bus-item2 {
    width: 100%;
    min-width: 0;

    .sale-bus-img2 {
      display: block;
      width: 100%;
      aspect-ratio: 4 / 3;
      object-fit: cover;
      border-radius: 10px;
      border: 1px solid #ccc;
      box-sizing: border-box;
    }

    .sale-bus-name2 {
      margin-top: 8px;
      text-align: center;
      font-size: 14px;
      font-weight: bold;
      line-height: 1.4;
      word-break: keep-all;
    }
  }

  @media (max-width: 768px) {
    grid-template-columns: repeat(2, 1fr);
    gap: 16px;

    .sale-bus-item2 {
      .sale-bus-name2 {
        font-size: 12px;
      }
    }
  }
}

  .sale-vietnam-img2 {
  width: 20%;
  height: 200px;
  object-fit: cover;
  border-radius: 12px;
}

.sale-bus-list2 .sale-vietnam-img2 {
  width: 100% !important;
}

  &.kor {
    .kor {
      display: block;
    }

    .eng {
      display: none;
    }

    .map-kor {
      display: block;
    }

    .map-eng {
      display: none;
    }
  }

  &.eng {
    .kor {
      display: none;
    }

    .eng {
      display: block;
    }

    .map-kor {
      display: none;
    }

    .map-eng {
      display: block;
    }
  }
`;

export const PageTopLine = styled.div`
  width: 1280px;
  margin: auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-top: 40px;
  padding-bottom: 40px;

  .page-top-line-title {
    font-size: 40px;
    color: var(--dark);
    font-weight: bold;
  }

  .page-top-line-left {
    img {
      width: 140px;
    }
  }
  .page-top-line-right {
    width: 140px;
  }
  @media (max-width: 1280px) {
    width: 90vw !important;
    margin: auto;
    display: block;
    text-align: center;
  }
`;
export const PageNavidation = styled.div`
  background-color: #faf8f6;
  box-shadow:0 2px 2px rgba(54,28,11,.05);
  border-bottom : 1px solid #ccc;
  height : 52px;
  display : flex;
  align-items : center;
 
  .logo{
    width : 80px;
    height : 100%;
    display : flex;
    align-items : center;
    justify-content : center;
    background-image: url(${NavBack}) ;
    background-repeat: no-repeat;
    background-position : right;
    svg{
      width : 13px;
      height : 11px;
    }
}

@media (max-width: 768px){

  &>div:nth-child(-n+2) {
    display : none !important;
  }

  &>a{
    display : none !important;
  }
    &>div{
      width : auto !important;
      padding-right : 60px;
      a{
      font-size : 14px;
      }
    }

  .open-list{
    left : 0px !important;
  font-size : 14px;
    }
}
.`;

export const Nav = styled.div`
  background-image: url(${NavBack});
  background-repeat: no-repeat;
  background-position: right;
  width: 24%;
  height: 52px;
  position: relative;
  .down-arrow {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    right: 32px;
  }

  cursor: pointer;
  &:hover .open-list,
  .open-list:hover {
    height: ${(props) => props.height};
    border: 1px solid #ccc;
    background-color: var(--white);
  }

  .open-list {
    position: absolute;
    top: 52px;
    left: -24px;
    box-sizing: border-box;
    z-index: 50;
    height: 0px;
    transition: all 0.2s ease-in-out;
    overflow: hidden;
    width: 100%;
    border: none;
  }
`;
export const NavItem = styled.div`
  height: 52px;
  display: flex;
  align-items: center;
  justify-content: left;
  font-size: 18px;
  width: 100%;
  padding-left: 23px;
  color: var(--navi);

  &.list-inner-item {
    &:hover {
      background-color: var(--semi-brown);
      text-decoration: underline;
    }
  }
`;

export const PageTitle = styled.div`
  display: flex;
  align-items: center;
  padding-top: 45px;

  .page-title-left {
    display: flex;
    align-items: center;
    min-width: 0;
  }

  .title-bar {
    display: block;
    width: 10px;
    min-width: 10px;
    height: 52px;
    background-color: var(--navi);
  }

  .title {
    margin-left: 20px;
    font-size: 36px;
    font-weight: bold;
    color: var(--dark);
    line-height: 1.2;
  }

  .page-title-actions {
    display: flex;
    align-items: center;
    gap: 10px;
    margin-left: auto;
  }

  .website-button,
  .status-button,
  .legacy-link-button {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
    min-height: 44px;
    margin: 0;
    padding: 6px 18px;
    border-radius: 22px;
    background-color: var(--navi);
    color: var(--white);
    font-size: 18px;
    line-height: 1;
    white-space: nowrap;
    text-decoration: none;
  }

  .website-button {
    gap: 10px;
    padding-left: 7px;
    cursor: pointer;
  }

  .website-button:hover,
  .legacy-link-button:hover {
    opacity: 0.85;
  }

  .website-icon {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 34px;
    min-width: 34px;
    height: 34px;
    
    box-sizing: border-box;
    font-size: 30px;
    line-height: 1;
  }

  .status-button {
    padding-left: 18px;
    padding-right: 18px;
    font-weight: bold;
  }

  .legacy-link-button {
    cursor: pointer;
  }

  .website-button.disabled {
    cursor: default;
    pointer-events: none;
    opacity: 0.9;
  }

  @media (max-width: 1024px) {
    flex-wrap: wrap;

    .page-title-actions {
      width: 100%;
      margin-top: 14px;
      margin-left: 30px;
    }
  }

  @media (max-width: 768px) {
    padding-top: 24px;

    .title-bar {
      width: 5px;
      min-width: 5px;
      height: 32px;
    }

    .title {
      margin-left: 12px;
      font-size: 24px;
    }

    .page-title-actions {
      flex-wrap: wrap;
      gap: 7px;
      margin-top: 12px;
      margin-left: 17px;
    }

    .website-button,
    .status-button,
    .legacy-link-button {
      min-height: 36px;
      padding: 5px 12px;
      border-radius: 18px;
      font-size: 14px;
    }

    .website-button {
      max-width: calc(100vw - 70px);
      padding-left: 5px;
    }

    .website-icon {
      width: 28px;
      min-width: 28px;
      height: 28px;
      font-size: 17px;
    }
    .website-icon svg {
      width: 24px;
      height: 24px;
    }
    .website-text {
      overflow: hidden;
      text-overflow: ellipsis;
    }

    .status-button {
      padding-left: 13px;
      padding-right: 13px;
    }
  }
`;

export const ImgHolderFullsize = styled.div`
  background-color: var(--navi);
  width: 100%;
  padding-top: 5px;
  border-radius: 28px;
  margin-top: 16px;
  .holder-img {
    width: calc(100% - 10px);
    border-radius: 23px;
    margin: auto;
    display: block;
    height: 400px;
    object-fit: cover;
  }

  .holder-name {
    padding-top: 5px;
    padding-bottom: 5px;
    font-size: 20px;
    text-align: center;
    color: var(--white);
  }

  .plus {
    object-fit: cover;
  }

  @media (max-width: 768px) {
    margin-top: 12px;
    border-radius: 15px;
    padding-top: 4px;
    .holder-img {
      border-radius: 10px;
      height: 120px;
      width: calc(100% - 8px);
    }
    .holder-name {
      font-size: 14px;
      padding-top: 4px;
      padding-bottom: 4px;
    }
  }
`;
export const ImgHolderFlex = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 16px;

  &.center {
    justify-content: center;
    gap: 24px;
    img {
      width: 40%;
    }
  }
  .fullsizeItem {
    width: 50% !important;
  }

  .flex-right {
    width: 48%;
    flex-wrap: wrap;
    gap: 12px !important;
    img {
      width: 100% !important;
      height: 150px !important;
      border: none !important;
    }
    & > div {
      width: calc(50% - 6px) !important;
      &.sale-bus-item-full {
        width: calc(100%) !important;
        img {
          width: 60% !important;
          height: 180px !important;
          display: block;
          margin: auto;
          object-fit: cover;
        }
      }
    }
  }

  @media (max-width: 768px) {
    margin-top: 12px;
    &.center {
      justify-content: center;
      gap: 12px;

      & > img {
        height: 120px;
      }
    }
  }
`;
export const ImgHolderHarf = styled.div`
  background-color: var(--navi);
  width: calc(50% - 8px);
  padding-top: 5px;
  border-radius: 28px;
  .holder-img {
    width: calc(100% - 10px);
    border-radius: 23px;
    margin: auto;
    display: block;
    height: 300px;
    object-fit: cover;
  }

  .holder-name {
    padding-top: 5px;
    padding-bottom: 5px;
    font-size: 20px;
    text-align: center;
    color: var(--white);
  }

  @media (max-width: 768px) {
    border-radius: 15px;
    width: calc(50% - 8px);

    padding-top: 4px;
    .holder-img {
      border-radius: 10px;
      height: 120px;
      width: calc(100% - 8px);
    }
    .holder-name {
      font-size: 14px;
      padding-top: 4px;
      padding-bottom: 4px;
    }
  }
`;

export const HistoryTable = styled.div`
  width: 100%;
  border-radius: 10px;
  border: 1px solid var(--navi);
  margin-top: 24px;
  overflow: hidden;

  .history-table-head {
    border-bottom: 1px solid var(--navi);
    display: flex;
    align-items: center;
    background-color: var(--navi);
    color: #fff;
    font-size: 16px;
    font-weight: bold;
    .history-table-ceil-big {
      padding-left: 20px;
    }
  }

  .history-table-line {
    border-bottom: 1px solid var(--navi);
    display: flex;

    font-size: 14px;
    font-weight: bold;
  }

  .history-table-ceil-small {
    width: 150px;
    border-right: 1px solid var(--navi);
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
    padding-bottom: 16px;
    padding-top: 16px;
  }
  .history-table-ceil-big {
    width: calc(100% - 150px);
    text-align: left;
    padding-bottom: 16px;
    padding-top: 16px;
  }

  .history-table-ceil-big > div {
    padding-left: 16px;
    padding-right: 16px;
  }
  .last-line {
    border-bottom: 0px !important;
  }
  .line {
    width: 100%;
    height: 1px;
    background-color: var(--navi);
    margin-top: 16px;
    margin-bottom: 16px;
  }
  .ceil-kor {
    font-weight: bold;
    @media (max-width: 768px) {
      word-break: keep-all;
    }
  }
  .ceil-end {
    font-weight: lighter;
  }
`;

export const SaleItemList = styled.div`
  display: flex;
  gap: 24px;
  flex-wrap: wrap;
  justify-content: center;
  margin-top: 24px;
`;
export const SaleItem = styled.div`
  width: calc((100% - 48px) / 3);
  background-color: var(--navi);
  border-radius: 20px;
  padding-top: 12px;
  padding-bottom: 12px;
  > img {
    width: calc(100% - 56px);
    padding: 16px;
    display: block;
    margin: auto;
    border-radius: 15px;
    height: 123px;
    background-color: var(--white);
  }
`;

export const AsList = styled.div`
  display: flex;
  gap: 24px;
  flex-wrap: wrap;
  margin-top: 32px;
  @media (max-width: 768px) {
    gap: 12px;
  }
`;
export const AsItem = styled.div`
  width: calc(50% - 12px);
  padding: 16px;
  box-sizing: border-box;

  .as-item-title {
    font-size: 24px;
    font-weight: bold;
    margin-bottom: 8px;
  }

  .as-item-imgArea {
    background-color: var(--navi);
    padding: 8px;
    width: 100%;
    box-sizing: border-box;
    border-radius: 20px;
    img {
      width: 100%;
      height: 300px;
      border-radius: 15px;
      object-fit: cover;
    }
  }

  .as-item-text {
    margin-top: 12px;
    line-height: 1.6;
    font-size: 18px;
  }

  @media (max-width: 768px) {
    width: calc(50% - 6px);
    padding: 0px;
    .as-item-title {
      font-size: 18px;
    }
    .as-item-imgArea {
      padding: 0px;
    }
    img {
      border-radius: 10px;

      height: 120px !important;
    }
    .as-item-text {
      margin-top: 8px;
      line-height: 1.3;
      font-size: 12px;
    }
  }
`;
